import { memo } from 'react';

import { OPopper } from '@src/shared';

import styles from '../MagicPenTools/magicPenTools.module.scss';

interface IMagicPenSubMenuProps {
  icon: React.ReactNode;
  label: string;
  children: React.ReactNode;
  isOpen?: boolean;
  tooltipContent?: string;
  triggerId?: string;
  popperId?: string;
  offset?: [number, number];
}

const MagicPenSubMenu = memo(
  ({
    icon,
    label,
    children,
    isOpen = false,
    tooltipContent,
    triggerId,
    popperId,
    offset = [6, 13],
  }: IMagicPenSubMenuProps) => {
    return (
      <OPopper
        isToolTipSmall={true}
        tooltipContent={tooltipContent}
        toolTipPlacement="right"
        icon={<div className={styles.button}>{icon}</div>}
        isOpen={isOpen}
        position="right-start"
        offset={offset}
        triggerId={triggerId}
        popperId={popperId}
        customStyles={{
          label: {
            opacity: '1',
            paddingLeft: '8px',
          },
          root: {
            border: '1px solid rgba(96, 99, 105, 1)',
            borderRadius: '9px',
          },
        }}
      >
        <div className={styles.popperLabel}>{label}</div>
        {children}
      </OPopper>
    );
  }
);

export default MagicPenSubMenu;
